











import { defineComponent } from "@vue/composition-api";
import { PaymentPackage } from "@scrile/api-provider/dist/api/PaymentPackageProvider";
import { formatMoneyString, getMainCurrencyCode } from "@/lib/moneyHelpers";
import BaseButton from "@/components/BaseButton";
import BaseConfirm from "@/components/BaseConfirm";

export default defineComponent({
  name: "PurchaseConfirmationView",
  components: { BaseConfirm, BaseButton },
  props: {
    value: { type: Boolean, required: true },
    packageId: { type: String, required: true },
    paymentPackages: { type: Array as () => PaymentPackage[], required: true },
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    price(): string {
      let amount = this.paymentPackages
        .find(pkg => pkg.id === this.packageId)
        ?.costs.find(cost => cost.currency === getMainCurrencyCode())?.cost;
      return (amount && formatMoneyString(amount, { currencyCode: getMainCurrencyCode() })) || "";
    },
  },
  methods: {
    purchase(cb: Function) {
      this.loading = true;
      this.$emit("purchase", (success: boolean = true) => {
        this.loading = false;
        success && cb();
      });
    },
  },
});
